// Widget Scripts
import cardWidgetHeaderLinks from './js/widgets/cardWidgetHeaderLinks.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
// if (window.location.pathname === '/') {
// }

$(document).ready(function () {
  cardWidgetHeaderLinks();
});
